export default {
    '/': {
        name: '首页',
        path: '/',
        fullPath: '/'
    },
    '/proposal':{
        name: '抵制网络谣言倡议书',
        path: '/proposal',
        fullPath: ''
    }
    // '/cart': {
    //     name: '购物车',
    //     path: '/cart',
    //     fullPath: ''
    // },
    // '/detail': {
    //     name: '宠物详情',
    //     path: '/detail',
    //     fullPath: ''
    // },
    // '/order': {
    //     name: '下单',
    //     path: '/order',
    //     fullPath: ''
    // },
    // '/my': {
    //     name: '我的',
    //     path: '/my',
    //     fullPath: ''
    // }
}
